export default __webpack_public_path__ + "static/media/js.83233e8d.png";